import React from 'react';
import PropTypes from 'prop-types';

import SrText from 'client/components/SrText';
import SrFlex from 'client/components/SrFlex';
import SrLink from 'client/components/SrLink/SrLink';

const SrLinkCard = ({
  title,
  label,
  linkLabel,
  linkTo,
  backgroundImageUrl,
}) => (
  <div
    className='SrLinkCard'
    style={!backgroundImageUrl ? null : {
      backgroundImage: `url(${backgroundImageUrl})`,
    }}
  >
    <SrLink to={linkTo}>
      <div className='cardContents cardLink'>
        <div>
          <SrText weight='bold' color='white' font='whitney-sc'>
            {title}
          </SrText>
        </div>
        <SrFlex justify='between'>
          <SrText color='white' weight='medium'>
            {label}
          </SrText>
          <SrText className='linkLabel' color='white' weight='medium'>
            {linkLabel}
          </SrText>
        </SrFlex>
      </div>
    </SrLink>
  </div>
);

SrLinkCard.propTypes = {
  title: PropTypes.string,
  label: PropTypes.string,
  backgroundImageUrl: PropTypes.string,
  linkLabel: PropTypes.string,
  linkTo: PropTypes.string,
};

SrLinkCard.defaultProps = {
  linkLabel: 'View',
};

SrLinkCard.displayName = 'SrLinkCard';

export default SrLinkCard;
